/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as ContactUsImport } from './routes/contact-us'
import { Route as BookmarksImport } from './routes/bookmarks'
import { Route as BookmarkImport } from './routes/bookmark'
import { Route as AboutUsImport } from './routes/about-us'
import { Route as ShopRouteImport } from './routes/_shop/route'
import { Route as FoodRouteImport } from './routes/_food/route'
import { Route as FlightRouteImport } from './routes/_flight/route'
import { Route as AccountRouteImport } from './routes/_account/route'
import { Route as IndexImport } from './routes/index'
import { Route as ChatIndexImport } from './routes/chat/index'
import { Route as RReferralIdImport } from './routes/r/$referralId'
import { Route as AuthSignUpImport } from './routes/auth/sign-up'
import { Route as AuthSignInImport } from './routes/auth/sign-in'
import { Route as AuthResetPasswordImport } from './routes/auth/reset-password'
import { Route as FoodTrackingFoodOrderIdIndexImport } from './routes/food-tracking/$foodOrderId/index'
import { Route as ShopShopIndexImport } from './routes/_shop/shop/index'
import { Route as ShopPaymentIndexImport } from './routes/_shop/payment/index'
import { Route as ShopFlashDealsIndexImport } from './routes/_shop/flash-deals/index'
import { Route as ShopChristmasSalesIndexImport } from './routes/_shop/christmas-sales/index'
import { Route as ShopCartIndexImport } from './routes/_shop/cart/index'
import { Route as FoodFoodIndexImport } from './routes/_food/food/index'
import { Route as FlightFlightsIndexImport } from './routes/_flight/flights/index'
import { Route as AccountRewardsIndexImport } from './routes/_account/rewards/index'
import { Route as AccountProfileIndexImport } from './routes/_account/profile/index'
import { Route as AccountOrdersIndexImport } from './routes/_account/orders/index'
import { Route as AccountOrderIndexImport } from './routes/_account/order/index'
import { Route as AccountFoodOrdersIndexImport } from './routes/_account/food-orders/index'
import { Route as AccountFlightBookingsIndexImport } from './routes/_account/flight-bookings/index'
import { Route as FoodFoodPaymentImport } from './routes/_food/food/payment'
import { Route as FoodFoodCartImport } from './routes/_food/food/cart'
import { Route as AccountAddressesIndexRouteImport } from './routes/_account/addresses/index/route'
import { Route as ShopProductProductIdIndexImport } from './routes/_shop/product/$productId/index'
import { Route as ShopCheckoutResultIndexImport } from './routes/_shop/checkout/$result/index'
import { Route as FoodStoreStoreIdIndexImport } from './routes/_food/store/$storeId/index'
import { Route as FlightFlightsCheckoutIndexImport } from './routes/_flight/flights/checkout/index'
import { Route as FlightFlightsFlightIdIndexImport } from './routes/_flight/flights/$flightId/index'
import { Route as AccountOrdersOrderIdIndexImport } from './routes/_account/orders/$orderId/index'
import { Route as AccountFoodOrdersFoodOrderIdIndexImport } from './routes/_account/food-orders/$foodOrderId/index'
import { Route as AccountFlightBookingsBookingIdIndexImport } from './routes/_account/flight-bookings/$bookingId/index'

// Create/Update Routes

const ContactUsRoute = ContactUsImport.update({
  id: '/contact-us',
  path: '/contact-us',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/contact-us.lazy').then((d) => d.Route))

const BookmarksRoute = BookmarksImport.update({
  id: '/bookmarks',
  path: '/bookmarks',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/bookmarks.lazy').then((d) => d.Route))

const BookmarkRoute = BookmarkImport.update({
  id: '/bookmark',
  path: '/bookmark',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/bookmark.lazy').then((d) => d.Route))

const AboutUsRoute = AboutUsImport.update({
  id: '/about-us',
  path: '/about-us',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/about-us.lazy').then((d) => d.Route))

const ShopRouteRoute = ShopRouteImport.update({
  id: '/_shop',
  getParentRoute: () => rootRoute,
} as any)

const FoodRouteRoute = FoodRouteImport.update({
  id: '/_food',
  getParentRoute: () => rootRoute,
} as any)

const FlightRouteRoute = FlightRouteImport.update({
  id: '/_flight',
  getParentRoute: () => rootRoute,
} as any)

const AccountRouteRoute = AccountRouteImport.update({
  id: '/_account',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/_account/route.lazy').then((d) => d.Route),
)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))

const ChatIndexRoute = ChatIndexImport.update({
  id: '/chat/',
  path: '/chat/',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/chat/index.lazy').then((d) => d.Route))

const RReferralIdRoute = RReferralIdImport.update({
  id: '/r/$referralId',
  path: '/r/$referralId',
  getParentRoute: () => rootRoute,
} as any)

const AuthSignUpRoute = AuthSignUpImport.update({
  id: '/auth/sign-up',
  path: '/auth/sign-up',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/auth/sign-up.lazy').then((d) => d.Route))

const AuthSignInRoute = AuthSignInImport.update({
  id: '/auth/sign-in',
  path: '/auth/sign-in',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/auth/sign-in.lazy').then((d) => d.Route))

const AuthResetPasswordRoute = AuthResetPasswordImport.update({
  id: '/auth/reset-password',
  path: '/auth/reset-password',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/auth/reset-password.lazy').then((d) => d.Route),
)

const FoodTrackingFoodOrderIdIndexRoute =
  FoodTrackingFoodOrderIdIndexImport.update({
    id: '/food-tracking/$foodOrderId/',
    path: '/food-tracking/$foodOrderId/',
    getParentRoute: () => rootRoute,
  } as any).lazy(() =>
    import('./routes/food-tracking/$foodOrderId/index.lazy').then(
      (d) => d.Route,
    ),
  )

const ShopShopIndexRoute = ShopShopIndexImport.update({
  id: '/shop/',
  path: '/shop/',
  getParentRoute: () => ShopRouteRoute,
} as any).lazy(() =>
  import('./routes/_shop/shop/index.lazy').then((d) => d.Route),
)

const ShopPaymentIndexRoute = ShopPaymentIndexImport.update({
  id: '/payment/',
  path: '/payment/',
  getParentRoute: () => ShopRouteRoute,
} as any).lazy(() =>
  import('./routes/_shop/payment/index.lazy').then((d) => d.Route),
)

const ShopFlashDealsIndexRoute = ShopFlashDealsIndexImport.update({
  id: '/flash-deals/',
  path: '/flash-deals/',
  getParentRoute: () => ShopRouteRoute,
} as any).lazy(() =>
  import('./routes/_shop/flash-deals/index.lazy').then((d) => d.Route),
)

const ShopChristmasSalesIndexRoute = ShopChristmasSalesIndexImport.update({
  id: '/christmas-sales/',
  path: '/christmas-sales/',
  getParentRoute: () => ShopRouteRoute,
} as any).lazy(() =>
  import('./routes/_shop/christmas-sales/index.lazy').then((d) => d.Route),
)

const ShopCartIndexRoute = ShopCartIndexImport.update({
  id: '/cart/',
  path: '/cart/',
  getParentRoute: () => ShopRouteRoute,
} as any).lazy(() =>
  import('./routes/_shop/cart/index.lazy').then((d) => d.Route),
)

const FoodFoodIndexRoute = FoodFoodIndexImport.update({
  id: '/food/',
  path: '/food/',
  getParentRoute: () => FoodRouteRoute,
} as any).lazy(() =>
  import('./routes/_food/food/index.lazy').then((d) => d.Route),
)

const FlightFlightsIndexRoute = FlightFlightsIndexImport.update({
  id: '/flights/',
  path: '/flights/',
  getParentRoute: () => FlightRouteRoute,
} as any).lazy(() =>
  import('./routes/_flight/flights/index.lazy').then((d) => d.Route),
)

const AccountRewardsIndexRoute = AccountRewardsIndexImport.update({
  id: '/rewards/',
  path: '/rewards/',
  getParentRoute: () => AccountRouteRoute,
} as any).lazy(() =>
  import('./routes/_account/rewards/index.lazy').then((d) => d.Route),
)

const AccountProfileIndexRoute = AccountProfileIndexImport.update({
  id: '/profile/',
  path: '/profile/',
  getParentRoute: () => AccountRouteRoute,
} as any).lazy(() =>
  import('./routes/_account/profile/index.lazy').then((d) => d.Route),
)

const AccountOrdersIndexRoute = AccountOrdersIndexImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => AccountRouteRoute,
} as any).lazy(() =>
  import('./routes/_account/orders/index.lazy').then((d) => d.Route),
)

const AccountOrderIndexRoute = AccountOrderIndexImport.update({
  id: '/order/',
  path: '/order/',
  getParentRoute: () => AccountRouteRoute,
} as any).lazy(() =>
  import('./routes/_account/order/index.lazy').then((d) => d.Route),
)

const AccountFoodOrdersIndexRoute = AccountFoodOrdersIndexImport.update({
  id: '/food-orders/',
  path: '/food-orders/',
  getParentRoute: () => AccountRouteRoute,
} as any).lazy(() =>
  import('./routes/_account/food-orders/index.lazy').then((d) => d.Route),
)

const AccountFlightBookingsIndexRoute = AccountFlightBookingsIndexImport.update(
  {
    id: '/flight-bookings/',
    path: '/flight-bookings/',
    getParentRoute: () => AccountRouteRoute,
  } as any,
).lazy(() =>
  import('./routes/_account/flight-bookings/index.lazy').then((d) => d.Route),
)

const FoodFoodPaymentRoute = FoodFoodPaymentImport.update({
  id: '/food/payment',
  path: '/food/payment',
  getParentRoute: () => FoodRouteRoute,
} as any).lazy(() =>
  import('./routes/_food/food/payment.lazy').then((d) => d.Route),
)

const FoodFoodCartRoute = FoodFoodCartImport.update({
  id: '/food/cart',
  path: '/food/cart',
  getParentRoute: () => FoodRouteRoute,
} as any).lazy(() =>
  import('./routes/_food/food/cart.lazy').then((d) => d.Route),
)

const AccountAddressesIndexRouteRoute = AccountAddressesIndexRouteImport.update(
  {
    id: '/addresses/',
    path: '/addresses/',
    getParentRoute: () => AccountRouteRoute,
  } as any,
).lazy(() =>
  import('./routes/_account/addresses/index/route.lazy').then((d) => d.Route),
)

const ShopProductProductIdIndexRoute = ShopProductProductIdIndexImport.update({
  id: '/product/$productId/',
  path: '/product/$productId/',
  getParentRoute: () => ShopRouteRoute,
} as any).lazy(() =>
  import('./routes/_shop/product/$productId/index.lazy').then((d) => d.Route),
)

const ShopCheckoutResultIndexRoute = ShopCheckoutResultIndexImport.update({
  id: '/checkout/$result/',
  path: '/checkout/$result/',
  getParentRoute: () => ShopRouteRoute,
} as any).lazy(() =>
  import('./routes/_shop/checkout/$result/index.lazy').then((d) => d.Route),
)

const FoodStoreStoreIdIndexRoute = FoodStoreStoreIdIndexImport.update({
  id: '/store/$storeId/',
  path: '/store/$storeId/',
  getParentRoute: () => FoodRouteRoute,
} as any).lazy(() =>
  import('./routes/_food/store/$storeId/index.lazy').then((d) => d.Route),
)

const FlightFlightsCheckoutIndexRoute = FlightFlightsCheckoutIndexImport.update(
  {
    id: '/flights/checkout/',
    path: '/flights/checkout/',
    getParentRoute: () => FlightRouteRoute,
  } as any,
).lazy(() =>
  import('./routes/_flight/flights/checkout/index.lazy').then((d) => d.Route),
)

const FlightFlightsFlightIdIndexRoute = FlightFlightsFlightIdIndexImport.update(
  {
    id: '/flights/$flightId/',
    path: '/flights/$flightId/',
    getParentRoute: () => FlightRouteRoute,
  } as any,
).lazy(() =>
  import('./routes/_flight/flights/$flightId/index.lazy').then((d) => d.Route),
)

const AccountOrdersOrderIdIndexRoute = AccountOrdersOrderIdIndexImport.update({
  id: '/orders/$orderId/',
  path: '/orders/$orderId/',
  getParentRoute: () => AccountRouteRoute,
} as any).lazy(() =>
  import('./routes/_account/orders/$orderId/index.lazy').then((d) => d.Route),
)

const AccountFoodOrdersFoodOrderIdIndexRoute =
  AccountFoodOrdersFoodOrderIdIndexImport.update({
    id: '/food-orders/$foodOrderId/',
    path: '/food-orders/$foodOrderId/',
    getParentRoute: () => AccountRouteRoute,
  } as any).lazy(() =>
    import('./routes/_account/food-orders/$foodOrderId/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AccountFlightBookingsBookingIdIndexRoute =
  AccountFlightBookingsBookingIdIndexImport.update({
    id: '/flight-bookings/$bookingId/',
    path: '/flight-bookings/$bookingId/',
    getParentRoute: () => AccountRouteRoute,
  } as any).lazy(() =>
    import('./routes/_account/flight-bookings/$bookingId/index.lazy').then(
      (d) => d.Route,
    ),
  )

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_account': {
      id: '/_account'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AccountRouteImport
      parentRoute: typeof rootRoute
    }
    '/_flight': {
      id: '/_flight'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof FlightRouteImport
      parentRoute: typeof rootRoute
    }
    '/_food': {
      id: '/_food'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof FoodRouteImport
      parentRoute: typeof rootRoute
    }
    '/_shop': {
      id: '/_shop'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof ShopRouteImport
      parentRoute: typeof rootRoute
    }
    '/about-us': {
      id: '/about-us'
      path: '/about-us'
      fullPath: '/about-us'
      preLoaderRoute: typeof AboutUsImport
      parentRoute: typeof rootRoute
    }
    '/bookmark': {
      id: '/bookmark'
      path: '/bookmark'
      fullPath: '/bookmark'
      preLoaderRoute: typeof BookmarkImport
      parentRoute: typeof rootRoute
    }
    '/bookmarks': {
      id: '/bookmarks'
      path: '/bookmarks'
      fullPath: '/bookmarks'
      preLoaderRoute: typeof BookmarksImport
      parentRoute: typeof rootRoute
    }
    '/contact-us': {
      id: '/contact-us'
      path: '/contact-us'
      fullPath: '/contact-us'
      preLoaderRoute: typeof ContactUsImport
      parentRoute: typeof rootRoute
    }
    '/auth/reset-password': {
      id: '/auth/reset-password'
      path: '/auth/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof AuthResetPasswordImport
      parentRoute: typeof rootRoute
    }
    '/auth/sign-in': {
      id: '/auth/sign-in'
      path: '/auth/sign-in'
      fullPath: '/auth/sign-in'
      preLoaderRoute: typeof AuthSignInImport
      parentRoute: typeof rootRoute
    }
    '/auth/sign-up': {
      id: '/auth/sign-up'
      path: '/auth/sign-up'
      fullPath: '/auth/sign-up'
      preLoaderRoute: typeof AuthSignUpImport
      parentRoute: typeof rootRoute
    }
    '/r/$referralId': {
      id: '/r/$referralId'
      path: '/r/$referralId'
      fullPath: '/r/$referralId'
      preLoaderRoute: typeof RReferralIdImport
      parentRoute: typeof rootRoute
    }
    '/chat/': {
      id: '/chat/'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof ChatIndexImport
      parentRoute: typeof rootRoute
    }
    '/_account/addresses/': {
      id: '/_account/addresses/'
      path: '/addresses'
      fullPath: '/addresses'
      preLoaderRoute: typeof AccountAddressesIndexRouteImport
      parentRoute: typeof AccountRouteImport
    }
    '/_food/food/cart': {
      id: '/_food/food/cart'
      path: '/food/cart'
      fullPath: '/food/cart'
      preLoaderRoute: typeof FoodFoodCartImport
      parentRoute: typeof FoodRouteImport
    }
    '/_food/food/payment': {
      id: '/_food/food/payment'
      path: '/food/payment'
      fullPath: '/food/payment'
      preLoaderRoute: typeof FoodFoodPaymentImport
      parentRoute: typeof FoodRouteImport
    }
    '/_account/flight-bookings/': {
      id: '/_account/flight-bookings/'
      path: '/flight-bookings'
      fullPath: '/flight-bookings'
      preLoaderRoute: typeof AccountFlightBookingsIndexImport
      parentRoute: typeof AccountRouteImport
    }
    '/_account/food-orders/': {
      id: '/_account/food-orders/'
      path: '/food-orders'
      fullPath: '/food-orders'
      preLoaderRoute: typeof AccountFoodOrdersIndexImport
      parentRoute: typeof AccountRouteImport
    }
    '/_account/order/': {
      id: '/_account/order/'
      path: '/order'
      fullPath: '/order'
      preLoaderRoute: typeof AccountOrderIndexImport
      parentRoute: typeof AccountRouteImport
    }
    '/_account/orders/': {
      id: '/_account/orders/'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof AccountOrdersIndexImport
      parentRoute: typeof AccountRouteImport
    }
    '/_account/profile/': {
      id: '/_account/profile/'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AccountProfileIndexImport
      parentRoute: typeof AccountRouteImport
    }
    '/_account/rewards/': {
      id: '/_account/rewards/'
      path: '/rewards'
      fullPath: '/rewards'
      preLoaderRoute: typeof AccountRewardsIndexImport
      parentRoute: typeof AccountRouteImport
    }
    '/_flight/flights/': {
      id: '/_flight/flights/'
      path: '/flights'
      fullPath: '/flights'
      preLoaderRoute: typeof FlightFlightsIndexImport
      parentRoute: typeof FlightRouteImport
    }
    '/_food/food/': {
      id: '/_food/food/'
      path: '/food'
      fullPath: '/food'
      preLoaderRoute: typeof FoodFoodIndexImport
      parentRoute: typeof FoodRouteImport
    }
    '/_shop/cart/': {
      id: '/_shop/cart/'
      path: '/cart'
      fullPath: '/cart'
      preLoaderRoute: typeof ShopCartIndexImport
      parentRoute: typeof ShopRouteImport
    }
    '/_shop/christmas-sales/': {
      id: '/_shop/christmas-sales/'
      path: '/christmas-sales'
      fullPath: '/christmas-sales'
      preLoaderRoute: typeof ShopChristmasSalesIndexImport
      parentRoute: typeof ShopRouteImport
    }
    '/_shop/flash-deals/': {
      id: '/_shop/flash-deals/'
      path: '/flash-deals'
      fullPath: '/flash-deals'
      preLoaderRoute: typeof ShopFlashDealsIndexImport
      parentRoute: typeof ShopRouteImport
    }
    '/_shop/payment/': {
      id: '/_shop/payment/'
      path: '/payment'
      fullPath: '/payment'
      preLoaderRoute: typeof ShopPaymentIndexImport
      parentRoute: typeof ShopRouteImport
    }
    '/_shop/shop/': {
      id: '/_shop/shop/'
      path: '/shop'
      fullPath: '/shop'
      preLoaderRoute: typeof ShopShopIndexImport
      parentRoute: typeof ShopRouteImport
    }
    '/food-tracking/$foodOrderId/': {
      id: '/food-tracking/$foodOrderId/'
      path: '/food-tracking/$foodOrderId'
      fullPath: '/food-tracking/$foodOrderId'
      preLoaderRoute: typeof FoodTrackingFoodOrderIdIndexImport
      parentRoute: typeof rootRoute
    }
    '/_account/flight-bookings/$bookingId/': {
      id: '/_account/flight-bookings/$bookingId/'
      path: '/flight-bookings/$bookingId'
      fullPath: '/flight-bookings/$bookingId'
      preLoaderRoute: typeof AccountFlightBookingsBookingIdIndexImport
      parentRoute: typeof AccountRouteImport
    }
    '/_account/food-orders/$foodOrderId/': {
      id: '/_account/food-orders/$foodOrderId/'
      path: '/food-orders/$foodOrderId'
      fullPath: '/food-orders/$foodOrderId'
      preLoaderRoute: typeof AccountFoodOrdersFoodOrderIdIndexImport
      parentRoute: typeof AccountRouteImport
    }
    '/_account/orders/$orderId/': {
      id: '/_account/orders/$orderId/'
      path: '/orders/$orderId'
      fullPath: '/orders/$orderId'
      preLoaderRoute: typeof AccountOrdersOrderIdIndexImport
      parentRoute: typeof AccountRouteImport
    }
    '/_flight/flights/$flightId/': {
      id: '/_flight/flights/$flightId/'
      path: '/flights/$flightId'
      fullPath: '/flights/$flightId'
      preLoaderRoute: typeof FlightFlightsFlightIdIndexImport
      parentRoute: typeof FlightRouteImport
    }
    '/_flight/flights/checkout/': {
      id: '/_flight/flights/checkout/'
      path: '/flights/checkout'
      fullPath: '/flights/checkout'
      preLoaderRoute: typeof FlightFlightsCheckoutIndexImport
      parentRoute: typeof FlightRouteImport
    }
    '/_food/store/$storeId/': {
      id: '/_food/store/$storeId/'
      path: '/store/$storeId'
      fullPath: '/store/$storeId'
      preLoaderRoute: typeof FoodStoreStoreIdIndexImport
      parentRoute: typeof FoodRouteImport
    }
    '/_shop/checkout/$result/': {
      id: '/_shop/checkout/$result/'
      path: '/checkout/$result'
      fullPath: '/checkout/$result'
      preLoaderRoute: typeof ShopCheckoutResultIndexImport
      parentRoute: typeof ShopRouteImport
    }
    '/_shop/product/$productId/': {
      id: '/_shop/product/$productId/'
      path: '/product/$productId'
      fullPath: '/product/$productId'
      preLoaderRoute: typeof ShopProductProductIdIndexImport
      parentRoute: typeof ShopRouteImport
    }
  }
}

// Create and export the route tree

interface AccountRouteRouteChildren {
  AccountAddressesIndexRouteRoute: typeof AccountAddressesIndexRouteRoute
  AccountFlightBookingsIndexRoute: typeof AccountFlightBookingsIndexRoute
  AccountFoodOrdersIndexRoute: typeof AccountFoodOrdersIndexRoute
  AccountOrderIndexRoute: typeof AccountOrderIndexRoute
  AccountOrdersIndexRoute: typeof AccountOrdersIndexRoute
  AccountProfileIndexRoute: typeof AccountProfileIndexRoute
  AccountRewardsIndexRoute: typeof AccountRewardsIndexRoute
  AccountFlightBookingsBookingIdIndexRoute: typeof AccountFlightBookingsBookingIdIndexRoute
  AccountFoodOrdersFoodOrderIdIndexRoute: typeof AccountFoodOrdersFoodOrderIdIndexRoute
  AccountOrdersOrderIdIndexRoute: typeof AccountOrdersOrderIdIndexRoute
}

const AccountRouteRouteChildren: AccountRouteRouteChildren = {
  AccountAddressesIndexRouteRoute: AccountAddressesIndexRouteRoute,
  AccountFlightBookingsIndexRoute: AccountFlightBookingsIndexRoute,
  AccountFoodOrdersIndexRoute: AccountFoodOrdersIndexRoute,
  AccountOrderIndexRoute: AccountOrderIndexRoute,
  AccountOrdersIndexRoute: AccountOrdersIndexRoute,
  AccountProfileIndexRoute: AccountProfileIndexRoute,
  AccountRewardsIndexRoute: AccountRewardsIndexRoute,
  AccountFlightBookingsBookingIdIndexRoute:
    AccountFlightBookingsBookingIdIndexRoute,
  AccountFoodOrdersFoodOrderIdIndexRoute:
    AccountFoodOrdersFoodOrderIdIndexRoute,
  AccountOrdersOrderIdIndexRoute: AccountOrdersOrderIdIndexRoute,
}

const AccountRouteRouteWithChildren = AccountRouteRoute._addFileChildren(
  AccountRouteRouteChildren,
)

interface FlightRouteRouteChildren {
  FlightFlightsIndexRoute: typeof FlightFlightsIndexRoute
  FlightFlightsFlightIdIndexRoute: typeof FlightFlightsFlightIdIndexRoute
  FlightFlightsCheckoutIndexRoute: typeof FlightFlightsCheckoutIndexRoute
}

const FlightRouteRouteChildren: FlightRouteRouteChildren = {
  FlightFlightsIndexRoute: FlightFlightsIndexRoute,
  FlightFlightsFlightIdIndexRoute: FlightFlightsFlightIdIndexRoute,
  FlightFlightsCheckoutIndexRoute: FlightFlightsCheckoutIndexRoute,
}

const FlightRouteRouteWithChildren = FlightRouteRoute._addFileChildren(
  FlightRouteRouteChildren,
)

interface FoodRouteRouteChildren {
  FoodFoodCartRoute: typeof FoodFoodCartRoute
  FoodFoodPaymentRoute: typeof FoodFoodPaymentRoute
  FoodFoodIndexRoute: typeof FoodFoodIndexRoute
  FoodStoreStoreIdIndexRoute: typeof FoodStoreStoreIdIndexRoute
}

const FoodRouteRouteChildren: FoodRouteRouteChildren = {
  FoodFoodCartRoute: FoodFoodCartRoute,
  FoodFoodPaymentRoute: FoodFoodPaymentRoute,
  FoodFoodIndexRoute: FoodFoodIndexRoute,
  FoodStoreStoreIdIndexRoute: FoodStoreStoreIdIndexRoute,
}

const FoodRouteRouteWithChildren = FoodRouteRoute._addFileChildren(
  FoodRouteRouteChildren,
)

interface ShopRouteRouteChildren {
  ShopCartIndexRoute: typeof ShopCartIndexRoute
  ShopChristmasSalesIndexRoute: typeof ShopChristmasSalesIndexRoute
  ShopFlashDealsIndexRoute: typeof ShopFlashDealsIndexRoute
  ShopPaymentIndexRoute: typeof ShopPaymentIndexRoute
  ShopShopIndexRoute: typeof ShopShopIndexRoute
  ShopCheckoutResultIndexRoute: typeof ShopCheckoutResultIndexRoute
  ShopProductProductIdIndexRoute: typeof ShopProductProductIdIndexRoute
}

const ShopRouteRouteChildren: ShopRouteRouteChildren = {
  ShopCartIndexRoute: ShopCartIndexRoute,
  ShopChristmasSalesIndexRoute: ShopChristmasSalesIndexRoute,
  ShopFlashDealsIndexRoute: ShopFlashDealsIndexRoute,
  ShopPaymentIndexRoute: ShopPaymentIndexRoute,
  ShopShopIndexRoute: ShopShopIndexRoute,
  ShopCheckoutResultIndexRoute: ShopCheckoutResultIndexRoute,
  ShopProductProductIdIndexRoute: ShopProductProductIdIndexRoute,
}

const ShopRouteRouteWithChildren = ShopRouteRoute._addFileChildren(
  ShopRouteRouteChildren,
)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '': typeof ShopRouteRouteWithChildren
  '/about-us': typeof AboutUsRoute
  '/bookmark': typeof BookmarkRoute
  '/bookmarks': typeof BookmarksRoute
  '/contact-us': typeof ContactUsRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/sign-in': typeof AuthSignInRoute
  '/auth/sign-up': typeof AuthSignUpRoute
  '/r/$referralId': typeof RReferralIdRoute
  '/chat': typeof ChatIndexRoute
  '/addresses': typeof AccountAddressesIndexRouteRoute
  '/food/cart': typeof FoodFoodCartRoute
  '/food/payment': typeof FoodFoodPaymentRoute
  '/flight-bookings': typeof AccountFlightBookingsIndexRoute
  '/food-orders': typeof AccountFoodOrdersIndexRoute
  '/order': typeof AccountOrderIndexRoute
  '/orders': typeof AccountOrdersIndexRoute
  '/profile': typeof AccountProfileIndexRoute
  '/rewards': typeof AccountRewardsIndexRoute
  '/flights': typeof FlightFlightsIndexRoute
  '/food': typeof FoodFoodIndexRoute
  '/cart': typeof ShopCartIndexRoute
  '/christmas-sales': typeof ShopChristmasSalesIndexRoute
  '/flash-deals': typeof ShopFlashDealsIndexRoute
  '/payment': typeof ShopPaymentIndexRoute
  '/shop': typeof ShopShopIndexRoute
  '/food-tracking/$foodOrderId': typeof FoodTrackingFoodOrderIdIndexRoute
  '/flight-bookings/$bookingId': typeof AccountFlightBookingsBookingIdIndexRoute
  '/food-orders/$foodOrderId': typeof AccountFoodOrdersFoodOrderIdIndexRoute
  '/orders/$orderId': typeof AccountOrdersOrderIdIndexRoute
  '/flights/$flightId': typeof FlightFlightsFlightIdIndexRoute
  '/flights/checkout': typeof FlightFlightsCheckoutIndexRoute
  '/store/$storeId': typeof FoodStoreStoreIdIndexRoute
  '/checkout/$result': typeof ShopCheckoutResultIndexRoute
  '/product/$productId': typeof ShopProductProductIdIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '': typeof ShopRouteRouteWithChildren
  '/about-us': typeof AboutUsRoute
  '/bookmark': typeof BookmarkRoute
  '/bookmarks': typeof BookmarksRoute
  '/contact-us': typeof ContactUsRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/sign-in': typeof AuthSignInRoute
  '/auth/sign-up': typeof AuthSignUpRoute
  '/r/$referralId': typeof RReferralIdRoute
  '/chat': typeof ChatIndexRoute
  '/addresses': typeof AccountAddressesIndexRouteRoute
  '/food/cart': typeof FoodFoodCartRoute
  '/food/payment': typeof FoodFoodPaymentRoute
  '/flight-bookings': typeof AccountFlightBookingsIndexRoute
  '/food-orders': typeof AccountFoodOrdersIndexRoute
  '/order': typeof AccountOrderIndexRoute
  '/orders': typeof AccountOrdersIndexRoute
  '/profile': typeof AccountProfileIndexRoute
  '/rewards': typeof AccountRewardsIndexRoute
  '/flights': typeof FlightFlightsIndexRoute
  '/food': typeof FoodFoodIndexRoute
  '/cart': typeof ShopCartIndexRoute
  '/christmas-sales': typeof ShopChristmasSalesIndexRoute
  '/flash-deals': typeof ShopFlashDealsIndexRoute
  '/payment': typeof ShopPaymentIndexRoute
  '/shop': typeof ShopShopIndexRoute
  '/food-tracking/$foodOrderId': typeof FoodTrackingFoodOrderIdIndexRoute
  '/flight-bookings/$bookingId': typeof AccountFlightBookingsBookingIdIndexRoute
  '/food-orders/$foodOrderId': typeof AccountFoodOrdersFoodOrderIdIndexRoute
  '/orders/$orderId': typeof AccountOrdersOrderIdIndexRoute
  '/flights/$flightId': typeof FlightFlightsFlightIdIndexRoute
  '/flights/checkout': typeof FlightFlightsCheckoutIndexRoute
  '/store/$storeId': typeof FoodStoreStoreIdIndexRoute
  '/checkout/$result': typeof ShopCheckoutResultIndexRoute
  '/product/$productId': typeof ShopProductProductIdIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/_account': typeof AccountRouteRouteWithChildren
  '/_flight': typeof FlightRouteRouteWithChildren
  '/_food': typeof FoodRouteRouteWithChildren
  '/_shop': typeof ShopRouteRouteWithChildren
  '/about-us': typeof AboutUsRoute
  '/bookmark': typeof BookmarkRoute
  '/bookmarks': typeof BookmarksRoute
  '/contact-us': typeof ContactUsRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/sign-in': typeof AuthSignInRoute
  '/auth/sign-up': typeof AuthSignUpRoute
  '/r/$referralId': typeof RReferralIdRoute
  '/chat/': typeof ChatIndexRoute
  '/_account/addresses/': typeof AccountAddressesIndexRouteRoute
  '/_food/food/cart': typeof FoodFoodCartRoute
  '/_food/food/payment': typeof FoodFoodPaymentRoute
  '/_account/flight-bookings/': typeof AccountFlightBookingsIndexRoute
  '/_account/food-orders/': typeof AccountFoodOrdersIndexRoute
  '/_account/order/': typeof AccountOrderIndexRoute
  '/_account/orders/': typeof AccountOrdersIndexRoute
  '/_account/profile/': typeof AccountProfileIndexRoute
  '/_account/rewards/': typeof AccountRewardsIndexRoute
  '/_flight/flights/': typeof FlightFlightsIndexRoute
  '/_food/food/': typeof FoodFoodIndexRoute
  '/_shop/cart/': typeof ShopCartIndexRoute
  '/_shop/christmas-sales/': typeof ShopChristmasSalesIndexRoute
  '/_shop/flash-deals/': typeof ShopFlashDealsIndexRoute
  '/_shop/payment/': typeof ShopPaymentIndexRoute
  '/_shop/shop/': typeof ShopShopIndexRoute
  '/food-tracking/$foodOrderId/': typeof FoodTrackingFoodOrderIdIndexRoute
  '/_account/flight-bookings/$bookingId/': typeof AccountFlightBookingsBookingIdIndexRoute
  '/_account/food-orders/$foodOrderId/': typeof AccountFoodOrdersFoodOrderIdIndexRoute
  '/_account/orders/$orderId/': typeof AccountOrdersOrderIdIndexRoute
  '/_flight/flights/$flightId/': typeof FlightFlightsFlightIdIndexRoute
  '/_flight/flights/checkout/': typeof FlightFlightsCheckoutIndexRoute
  '/_food/store/$storeId/': typeof FoodStoreStoreIdIndexRoute
  '/_shop/checkout/$result/': typeof ShopCheckoutResultIndexRoute
  '/_shop/product/$productId/': typeof ShopProductProductIdIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | ''
    | '/about-us'
    | '/bookmark'
    | '/bookmarks'
    | '/contact-us'
    | '/auth/reset-password'
    | '/auth/sign-in'
    | '/auth/sign-up'
    | '/r/$referralId'
    | '/chat'
    | '/addresses'
    | '/food/cart'
    | '/food/payment'
    | '/flight-bookings'
    | '/food-orders'
    | '/order'
    | '/orders'
    | '/profile'
    | '/rewards'
    | '/flights'
    | '/food'
    | '/cart'
    | '/christmas-sales'
    | '/flash-deals'
    | '/payment'
    | '/shop'
    | '/food-tracking/$foodOrderId'
    | '/flight-bookings/$bookingId'
    | '/food-orders/$foodOrderId'
    | '/orders/$orderId'
    | '/flights/$flightId'
    | '/flights/checkout'
    | '/store/$storeId'
    | '/checkout/$result'
    | '/product/$productId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | ''
    | '/about-us'
    | '/bookmark'
    | '/bookmarks'
    | '/contact-us'
    | '/auth/reset-password'
    | '/auth/sign-in'
    | '/auth/sign-up'
    | '/r/$referralId'
    | '/chat'
    | '/addresses'
    | '/food/cart'
    | '/food/payment'
    | '/flight-bookings'
    | '/food-orders'
    | '/order'
    | '/orders'
    | '/profile'
    | '/rewards'
    | '/flights'
    | '/food'
    | '/cart'
    | '/christmas-sales'
    | '/flash-deals'
    | '/payment'
    | '/shop'
    | '/food-tracking/$foodOrderId'
    | '/flight-bookings/$bookingId'
    | '/food-orders/$foodOrderId'
    | '/orders/$orderId'
    | '/flights/$flightId'
    | '/flights/checkout'
    | '/store/$storeId'
    | '/checkout/$result'
    | '/product/$productId'
  id:
    | '__root__'
    | '/'
    | '/_account'
    | '/_flight'
    | '/_food'
    | '/_shop'
    | '/about-us'
    | '/bookmark'
    | '/bookmarks'
    | '/contact-us'
    | '/auth/reset-password'
    | '/auth/sign-in'
    | '/auth/sign-up'
    | '/r/$referralId'
    | '/chat/'
    | '/_account/addresses/'
    | '/_food/food/cart'
    | '/_food/food/payment'
    | '/_account/flight-bookings/'
    | '/_account/food-orders/'
    | '/_account/order/'
    | '/_account/orders/'
    | '/_account/profile/'
    | '/_account/rewards/'
    | '/_flight/flights/'
    | '/_food/food/'
    | '/_shop/cart/'
    | '/_shop/christmas-sales/'
    | '/_shop/flash-deals/'
    | '/_shop/payment/'
    | '/_shop/shop/'
    | '/food-tracking/$foodOrderId/'
    | '/_account/flight-bookings/$bookingId/'
    | '/_account/food-orders/$foodOrderId/'
    | '/_account/orders/$orderId/'
    | '/_flight/flights/$flightId/'
    | '/_flight/flights/checkout/'
    | '/_food/store/$storeId/'
    | '/_shop/checkout/$result/'
    | '/_shop/product/$productId/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccountRouteRoute: typeof AccountRouteRouteWithChildren
  FlightRouteRoute: typeof FlightRouteRouteWithChildren
  FoodRouteRoute: typeof FoodRouteRouteWithChildren
  ShopRouteRoute: typeof ShopRouteRouteWithChildren
  AboutUsRoute: typeof AboutUsRoute
  BookmarkRoute: typeof BookmarkRoute
  BookmarksRoute: typeof BookmarksRoute
  ContactUsRoute: typeof ContactUsRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthSignInRoute: typeof AuthSignInRoute
  AuthSignUpRoute: typeof AuthSignUpRoute
  RReferralIdRoute: typeof RReferralIdRoute
  ChatIndexRoute: typeof ChatIndexRoute
  FoodTrackingFoodOrderIdIndexRoute: typeof FoodTrackingFoodOrderIdIndexRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccountRouteRoute: AccountRouteRouteWithChildren,
  FlightRouteRoute: FlightRouteRouteWithChildren,
  FoodRouteRoute: FoodRouteRouteWithChildren,
  ShopRouteRoute: ShopRouteRouteWithChildren,
  AboutUsRoute: AboutUsRoute,
  BookmarkRoute: BookmarkRoute,
  BookmarksRoute: BookmarksRoute,
  ContactUsRoute: ContactUsRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthSignInRoute: AuthSignInRoute,
  AuthSignUpRoute: AuthSignUpRoute,
  RReferralIdRoute: RReferralIdRoute,
  ChatIndexRoute: ChatIndexRoute,
  FoodTrackingFoodOrderIdIndexRoute: FoodTrackingFoodOrderIdIndexRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_account",
        "/_flight",
        "/_food",
        "/_shop",
        "/about-us",
        "/bookmark",
        "/bookmarks",
        "/contact-us",
        "/auth/reset-password",
        "/auth/sign-in",
        "/auth/sign-up",
        "/r/$referralId",
        "/chat/",
        "/food-tracking/$foodOrderId/"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_account": {
      "filePath": "_account/route.tsx",
      "children": [
        "/_account/addresses/",
        "/_account/flight-bookings/",
        "/_account/food-orders/",
        "/_account/order/",
        "/_account/orders/",
        "/_account/profile/",
        "/_account/rewards/",
        "/_account/flight-bookings/$bookingId/",
        "/_account/food-orders/$foodOrderId/",
        "/_account/orders/$orderId/"
      ]
    },
    "/_flight": {
      "filePath": "_flight/route.tsx",
      "children": [
        "/_flight/flights/",
        "/_flight/flights/$flightId/",
        "/_flight/flights/checkout/"
      ]
    },
    "/_food": {
      "filePath": "_food/route.tsx",
      "children": [
        "/_food/food/cart",
        "/_food/food/payment",
        "/_food/food/",
        "/_food/store/$storeId/"
      ]
    },
    "/_shop": {
      "filePath": "_shop/route.tsx",
      "children": [
        "/_shop/cart/",
        "/_shop/christmas-sales/",
        "/_shop/flash-deals/",
        "/_shop/payment/",
        "/_shop/shop/",
        "/_shop/checkout/$result/",
        "/_shop/product/$productId/"
      ]
    },
    "/about-us": {
      "filePath": "about-us.tsx"
    },
    "/bookmark": {
      "filePath": "bookmark.tsx"
    },
    "/bookmarks": {
      "filePath": "bookmarks.tsx"
    },
    "/contact-us": {
      "filePath": "contact-us.tsx"
    },
    "/auth/reset-password": {
      "filePath": "auth/reset-password.tsx"
    },
    "/auth/sign-in": {
      "filePath": "auth/sign-in.tsx"
    },
    "/auth/sign-up": {
      "filePath": "auth/sign-up.tsx"
    },
    "/r/$referralId": {
      "filePath": "r/$referralId.tsx"
    },
    "/chat/": {
      "filePath": "chat/index.tsx"
    },
    "/_account/addresses/": {
      "filePath": "_account/addresses/index/route.tsx",
      "parent": "/_account"
    },
    "/_food/food/cart": {
      "filePath": "_food/food/cart.tsx",
      "parent": "/_food"
    },
    "/_food/food/payment": {
      "filePath": "_food/food/payment.tsx",
      "parent": "/_food"
    },
    "/_account/flight-bookings/": {
      "filePath": "_account/flight-bookings/index.tsx",
      "parent": "/_account"
    },
    "/_account/food-orders/": {
      "filePath": "_account/food-orders/index.tsx",
      "parent": "/_account"
    },
    "/_account/order/": {
      "filePath": "_account/order/index.tsx",
      "parent": "/_account"
    },
    "/_account/orders/": {
      "filePath": "_account/orders/index.tsx",
      "parent": "/_account"
    },
    "/_account/profile/": {
      "filePath": "_account/profile/index.tsx",
      "parent": "/_account"
    },
    "/_account/rewards/": {
      "filePath": "_account/rewards/index.tsx",
      "parent": "/_account"
    },
    "/_flight/flights/": {
      "filePath": "_flight/flights/index.tsx",
      "parent": "/_flight"
    },
    "/_food/food/": {
      "filePath": "_food/food/index.tsx",
      "parent": "/_food"
    },
    "/_shop/cart/": {
      "filePath": "_shop/cart/index.tsx",
      "parent": "/_shop"
    },
    "/_shop/christmas-sales/": {
      "filePath": "_shop/christmas-sales/index.tsx",
      "parent": "/_shop"
    },
    "/_shop/flash-deals/": {
      "filePath": "_shop/flash-deals/index.tsx",
      "parent": "/_shop"
    },
    "/_shop/payment/": {
      "filePath": "_shop/payment/index.tsx",
      "parent": "/_shop"
    },
    "/_shop/shop/": {
      "filePath": "_shop/shop/index.tsx",
      "parent": "/_shop"
    },
    "/food-tracking/$foodOrderId/": {
      "filePath": "food-tracking/$foodOrderId/index.tsx"
    },
    "/_account/flight-bookings/$bookingId/": {
      "filePath": "_account/flight-bookings/$bookingId/index.tsx",
      "parent": "/_account"
    },
    "/_account/food-orders/$foodOrderId/": {
      "filePath": "_account/food-orders/$foodOrderId/index.tsx",
      "parent": "/_account"
    },
    "/_account/orders/$orderId/": {
      "filePath": "_account/orders/$orderId/index.tsx",
      "parent": "/_account"
    },
    "/_flight/flights/$flightId/": {
      "filePath": "_flight/flights/$flightId/index.tsx",
      "parent": "/_flight"
    },
    "/_flight/flights/checkout/": {
      "filePath": "_flight/flights/checkout/index.tsx",
      "parent": "/_flight"
    },
    "/_food/store/$storeId/": {
      "filePath": "_food/store/$storeId/index.tsx",
      "parent": "/_food"
    },
    "/_shop/checkout/$result/": {
      "filePath": "_shop/checkout/$result/index.tsx",
      "parent": "/_shop"
    },
    "/_shop/product/$productId/": {
      "filePath": "_shop/product/$productId/index.tsx",
      "parent": "/_shop"
    }
  }
}
ROUTE_MANIFEST_END */
